// FT-217 REQ-08 / SC-08: высота виджета «Свободно на ближайшие дни» по числу строк.
//
// Высоту ячейки сетки главной задаёт сервер (WIDGET_DIMENSIONS, h = 8 рядов), а
// строк у виджета столько, сколько у филиала ценовых групп (p90 прода — 6 групп +
// «Без цены» + «Всего»), да ещё строка «своих · партн.» у admin. В фиксированной
// высоте строка «Всего» обрезалась, а в мобильной раскладке (виджеты столбиком по
// item.h) была видна одна строка. Поэтому высота ячейки считается по содержимому:
// до рендера — оценкой по числу строк, после — по замеру виджета; серверная h —
// нижняя граница. Это вычисляемый вид: на
// сервер уходит прежняя h (см. layoutHeightToSave).
//
// Пиксели оценки — замер вёрстки виджета на desktop (Vuetify 2, v-simple-table dense):
const PX = {
  title: 56, // v-card-title с pb-2
  head: 46, // шапка дней: название + дата
  row: 30, // строка «N из M»
  rowSplit: 50, // строка с «своих N · партн. N»
  footer: 40, // «Ценовые группы ещё не собраны» + «Собрать группы»
  padding: 16, // нижний отступ карточки и запас
};
// Больше строк ячейка не растёт — дальше прокрутка внутри карточки.
export const MAX_VISIBLE_ROWS = 10;

// Строки виджета: группы (если есть) + «Всего»; есть ли разбивка партнёра.
export function freeCarsUpcomingRows(data) {
  if (!data) return { rows: 0, split: false, footer: false };
  const groups = data.has_groups === false ? [] : data.rows || [];
  const all = groups.concat(data.total_row ? [data.total_row] : []);
  const split = all.some((row) => (row.cells || []).some((c) => c.free_own != null && c.free_partner != null));
  return { rows: all.length, split, footer: data.has_groups === false };
}

// Пиксели → ряды сетки: px = rowHeight·h + margin·(h − 1) (vue-grid-layout) →
// h = ⌈(px + margin) / (rowHeight + margin)⌉; не меньше minH.
export function gridRowsForPx(px, { rowHeight = 30, margin = 10, minH = 0 } = {}) {
  if (!px || px <= 0) return minH;
  return Math.max(minH, Math.ceil((px + margin) / (rowHeight + margin)));
}

// Первая оценка до рендера — по числу строк. Окончательную высоту даёт замер
// содержимого виджета (на узком экране строки бывают выше табличных).
export function freeCarsUpcomingHeight(data, opts = {}) {
  const { rows, split, footer } = freeCarsUpcomingRows(data);
  if (!rows) return opts.minH || 0;
  const visible = Math.min(rows, MAX_VISIBLE_ROWS);
  const px = PX.title + PX.head + visible * (split ? PX.rowSplit : PX.row) + (footer ? PX.footer : 0) + PX.padding;
  return gridRowsForPx(px, opts);
}

function collides(a, b) {
  return a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h;
}

// Ставит виджету высоту h и сдвигает вниз тех, на кого он теперь наезжает (и далее
// по цепочке). Сетка главной — prevent-collision без vertical-compact: сама она
// программную смену h не разводит. Сдвигаются только реально пересёкшиеся, поэтому
// повторная подгонка уже разведённой раскладки ничего не двигает. Мобильная
// раскладка — тот же столбик x = 0, и следующие виджеты так же съезжают вниз.
export function setWidgetHeight(widgets, widget, h) {
  if (!widget || widget.h === h) return;
  widget.h = h;
  const placed = [widget];
  widgets
    .filter((w) => w !== widget)
    .sort((a, b) => a.y - b.y || a.x - b.x)
    .forEach((w) => {
      let moved = true;
      while (moved) {
        moved = false;
        placed.forEach((p) => {
          if (collides(p, w)) {
            w.y = p.y + p.h;
            moved = true;
          }
        });
      }
      placed.push(w);
    });
}

// h, которую сохранять на сервер: подогнанную высоту — нет (это вид, а не выбор
// человека), но если человек растянул виджет сам, сохраняется его высота.
export function layoutHeightToSave(widget) {
  if (widget.autoBaseH != null && widget.h === widget.autoFitH) return widget.autoBaseH;
  return widget.h;
}
